import { render, staticRenderFns } from "./LockScroll.vue?vue&type=template&id=1245df45&"
import script from "./LockScroll.vue?vue&type=script&lang=js&"
export * from "./LockScroll.vue?vue&type=script&lang=js&"
import style0 from "./LockScroll.vue?vue&type=style&index=0&id=1245df45&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports